import { useObserve } from '@legendapp/state/react';
import { Box, type BoxProps } from '@mantine/core';
import { usePixiSpineAnimation } from '../hooks/usePixiSpineAnimation.hook';
import { ratAnimationState$ } from '../state';
import styles from './RatAnimation.module.css';

export type RatAnimationProps = BoxProps;

export const RatAnimation = (props: RatAnimationProps) => {
  const { containerRef, spineRef } = usePixiSpineAnimation({
    jsonUrl: '/spine/rat.json',
    atlasUrl: '/spine/rat_idle2.atlas',
    animationName: 'idle',
    scale: 0.2,
    speed: 1,
  });

  useObserve(ratAnimationState$.animationType, ({ value }) => {
    if (value && spineRef.current) {
      spineRef.current.skeleton.data.animations.map((a) => a.name);
      spineRef.current.state.setAnimation(0, value, true);
    }
  });

  return (
    <Box
      className={styles['rat-animation-container']}
      data-test-id="rat-animation"
      pos="absolute"
      ref={containerRef}
      style={{
        zIndex: 20,
      }}
      {...props}
    />
  );
};
